<app-header></app-header>

<div class="row wizard-row">
  <div class="col-md-12 fuelux">
    <div class="block-wizard panel panel-default">
      <div id="wizard1" class="wizard wizard-ux">
        <ul class="steps">
          <li data-step="1"><a href="dados-pessoais/{{codigo_pessoa}}">Dados Pessoais</a><span class="chevron"></span></li>
          <li data-step="2"><a href="dados-financeiros/{{codigo_pessoa}}">Dados Financeiros</a><span class="chevron"></span></li>
          <li data-step="3"><a href="dados-administrativos/{{codigo_pessoa}}">Dados Administrativos</a><span class="chevron"></span></li>
          <li data-step="4"><a href="dados-controle/{{codigo_pessoa}}">Dados de Controle</a><span class="chevron"></span></li>
          <li data-step="5"><a href="dados-complementares/{{codigo_pessoa}}">Dados Complementares</a><span class="chevron"></span></li>
          <li data-step="6" class="active"><a href="dados-observacao/{{codigo_pessoa}}">Observações</a><span class="chevron"></span></li>
        </ul>
        <div class="step-content">
          <div *ngIf="!carregando" style="text-align: center;"><img src="/assets/img/carregando_tabela.gif"></div>
          <div data-step="1" class="step-pane active" *ngIf="carregando">
            <div id="apcf_sindical" class="tab-pane cont">
              <button data-toggle="modal" data-target="#formObservacao" (click)="limpar()" class="btn btn-space btn-success" tabindex="0" aria-controls="table3">Nova Observação</button>
              <table id="table2" class="table table-striped table-hover table-fw-widget">
                  <thead>
                      <tr>
                          <th>Descrição</th>
                          <th>Data</th>
                          <th class="text-center">Ações</th>
                      </tr>
                  </thead>
                  <tbody *ngIf="observacoes && observacoes.length > 0">
                      <tr class="odd gradeX" *ngFor="let observacao of observacoes; let i = index;">
                          <td class="col-md-7">{{observacao.descricao}}</td>
                          <td class="col-md-3">{{observacao.created_at | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                          <td class="col-md-2 text-center" style="font-size: 22px;">
                              <span>
                                  <a data-toggle="modal" data-target="#formObservacao" (click)="carregar(observacao.codigo_observacao);definirCodigo(observacao.codigo_observacao)"><span class="mdi mdi-edit"></span></a>
                                  &nbsp;
                                  <a data-toggle="modal" data-target="#md-footer-delete" (click)="definirCodigo(observacao.codigo_observacao)"><span class="icon mdi mdi-delete"></span></a>
                              </span>
                          </td>
                      </tr>
                  </tbody>
                  <tbody *ngIf="observacoes && observacoes.length == 0">
                    <tr>
                        <td class="col-md-12" colspan="7">
                            Nenhum registro encontrado.
                        </td>
                    </tr>
                </tbody>
              </table>
            </div>
            <div class="form-group">
              <div class="col-9">
                <a href="dados-complementares/{{codigo_pessoa}}" data-wizard="#wizard1" class="btn btn-primary btn-space wizard-next">Anterior</a>&nbsp;&nbsp;&nbsp;&nbsp;
                <button type="button" data-toggle="modal" data-target="#formFinalizarCadastro" class="btn btn-success btn-space" [disabled]="carregando_finalizar">Finalizar Cadastro</button>
                &nbsp; <img *ngIf="carregando_salvar" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Modal Situacao Apcf Sindical-->
<div id="formObservacao" tabindex="-1" role="dialog" class="modal fade colored-header colored-header-primary">
  <div class="modal-dialog">
      <div class="modal-content">
          <div class="modal-header">
              <button type="button" data-dismiss="modal" aria-hidden="true" class="close md-close"><span class="mdi mdi-close"></span></button>
              <h3 class="modal-title"><span>Nova Observação</span></h3>
          </div>
          <div class="modal-body">
            <form #associadoObservacaoForm="ngForm" [formGroup]="form" data-parsley-namespace="data-parsley-" data-parsley-validate="" novalidate="" class="form-horizontal group-border-dashed">
              <div class="form-group">
                <label class="col-3 control-label">Observações</label>
                <div class="col-9">
                  <textarea cols="10" rows="8" class="form-control" formControlName="descricao"></textarea>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
              <button type="button" data-dismiss="modal" (click)="limpar()" class="btn btn-default md-close">Cancelar</button>
              <button type="button" data-dismiss="modal" class="btn btn-primary md-close" (click)="onSubmit()">Confirmar</button>
          </div>
      </div>
  </div>
</div>


<div id="formFinalizarCadastro" tabindex="-1" role="dialog" class="modal fade">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" data-dismiss="modal" aria-hidden="true" class="close"><span class="mdi mdi-close"></span></button>
        <h3 class="modal-title">Finalizar Cadastro</h3>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <div class="text-success"><span class="modal-main-icon mdi mdi-check-circle"></span></div>
          <h3>Tem certeza que deseja finalizar este cadastro?</h3>
          <p>O associado passará a aparecer na listagem de associados.</p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" data-dismiss="modal" class="btn btn-default">Cancelar</button>
        <button type="button" data-dismiss="modal" class="btn btn-success" (click)="finalizarCadastro()">Confirmar</button>
      </div>
    </div>
  </div>
</div>

<!--Modal Footer-->
<div id="md-footer-delete" tabindex="-1" role="dialog" style="" class="modal fade">
  <div class="modal-dialog">
      <div class="modal-content">
          <div class="modal-header">
              <button type="button" data-dismiss="modal" aria-hidden="true" class="close"><span class="mdi mdi-close"></span></button>
          </div>
          <div class="modal-body">
              <div class="text-center">
                  <div class="text-warning"><span class="modal-main-icon mdi mdi-alert-triangle"></span></div>
              <h3>Tem certeza que deseja excluir este registro?</h3>
              <p>Esta operação não poderá ser desfeita.</p>
              </div>
          </div>
          <div class="modal-footer">
              <button type="button" data-dismiss="modal" (click)="limpar()" class="btn btn-default">Cancelar</button>
              <button type="button" data-dismiss="modal" class="btn btn-warning" (click)="apagar(codigo_observacao)">Confirmar</button>
          </div>
      </div>
  </div>
</div>

<app-footer></app-footer>
